import { CalculatorId } from '../../../lib/calculators/calculator-config';
import type { CalculatorDescription } from '../../../lib/calculators/calculator-description';

export const correlationDescription: CalculatorDescription = {
  id: CalculatorId.CORRELATION_COEFFICIENT,
  title: 'Pearson Correlation Calculator',
  metaTitle: 'Online Pearson Correlation Calculator - Linear Relationship Analysis Tool',
  description: 'Calculate Pearson correlation coefficient (r) to measure the strength and direction of linear relationships between two variables. Includes statistical significance testing and R² analysis.',
  metaDescription: 'Calculate Pearson correlation coefficient online. Analyze linear relationships between variables with our free calculator. Test statistical significance and interpret results.',
  howTo: {
    title: 'How to Use the Pearson Correlation Calculator',
    steps: [
      'Enter paired data values for two variables',
      'Select independent (X) and dependent (Y) variables',
      'View the correlation coefficient (r) and significance',
      'Interpret the strength and direction of the relationship',
      'Analyze the coefficient of determination (R²)'
    ],
    graphic: {
      description: 'A scatter plot showing the linear relationship between variables with correlation line, r-value, and statistical significance'
    }
  },
  examples: [
    {
      title: 'Marketing Analysis',
      description: 'Analyzing relationship between advertising spend and sales',
      dataDescription: 'Monthly advertising expenditure and corresponding sales revenue',
      insights: [
        'Measures linear relationship',
        'Tests statistical significance',
        'Quantifies relationship strength',
        'Guides marketing decisions'
      ]
    },
    {
      title: 'Academic Performance',
      description: 'Analyzing relationship between study time and test scores',
      dataDescription: 'Weekly study hours and exam scores data',
      insights: [
        'Evaluates linear correlation',
        'Shows relationship direction',
        'Indicates predictive power',
        'Informs study strategies'
      ]
    }
  ],
  relatedCalculators: [
    CalculatorId.ScatterChart,
    CalculatorId.STANDARD_DEVIATION,
    CalculatorId.MEAN
  ]
}; 